import DefaultsAPI from "@/api/DefaultsAPI"
import { Defaults } from "@/store/modules"
import { IS_RANCHFORCE } from "@/constants"
import Vue, { markRaw } from "vue"

import { MAX_DEFAULT_FIELDS } from "@/constants/defaults"
import { BIconChevronCompactLeft } from "bootstrap-vue"

const state = {
  defaults: {},
  fieldSettings: {},
  newFieldSettings: {},
  cacheFieldSettings:{},
  opsSettings: {},
  fertSettings: {},
  practiceChoices: {},
  pasturePaddocks: {},
  spreadsheetNeedsSave: false,
  recentWizardData: { wizard: null, data: null },
}

const getters = {
  [Defaults.Getters.getDefaultsList]: state => {
    return Object.values(state.defaults).sort(
      (a, b) => b.fields_count - a.fields_count
    )
  },
  [Defaults.Getters.getOneFieldSettings]: state => fieldId => {
    return [[fieldId, state.newFieldSettings[fieldId]]]
  },
  [Defaults.Getters.getNewFieldSettings]: state => {
   
    return Object.entries(state.newFieldSettings)
  },
  [Defaults.Getters.getRecentWizardData]: state => {
    return state.recentWizardData
  },
  [Defaults.Getters.getPracticeChoices]: state => {
    return state.practiceChoices
  },
  [Defaults.Getters.getCacheFieldSettings]: state => {
    return state.cacheFieldSettings
  },
  [Defaults.Getters.isFieldInCache]: state => (fieldId,year,row,cell) => {
    return !!state.cacheFieldSettings?.[fieldId]?.[year]?.[row]?.[cell]
  },
  [Defaults.Getters.getPasturePaddocks]: state => {
    return state.pasturePaddocks
  },
}

const mutations = {
  [Defaults.Mutations.setDefaults](state, defaults) {
    const defaultsDict = {}
    defaults.forEach(item => (defaultsDict[item.id] = item))
    state.defaults = defaultsDict
  },
  [Defaults.Mutations.setFieldSettings](state, fieldSettings) {
    const fieldSettingsDict = {}
    fieldSettings.forEach(item => (fieldSettingsDict[item.id] = item))
    state.fieldSettings = fieldSettingsDict
  },
  // new code for arva pre-generated values
  [Defaults.Mutations.setNewFieldSettings](state, newFieldSettings) {
    state.newFieldSettings = JSON.parse(newFieldSettings)
  },
  [Defaults.Mutations.addToFieldSettings](state, fieldSettingsToAdd) {
    const addObj = JSON.parse(fieldSettingsToAdd)
    // addObj.forEach(data => {
    //   console.log("data ----", data);
    //   Vue.set(state.newFieldSettings, data.field_id, markRaw(data))
    // })

    function freezeDeep(obj) {
      Object.freeze(obj)
      for (const key in obj) {
        if (
          obj[key] &&
          typeof obj[key] === 'object' &&
          !Object.isFrozen(obj[key])
        ) {
          freezeDeep(obj[key])
        }
      }
      return obj
    }

    const batch = {}

    for (let i = 0; i < addObj.length; i++) {
      const { field_id, ...yearData } = addObj[i]

      // Freeze each field's data
      batch[field_id] = freezeDeep(yearData)
    }

    // 🔥 SINGLE reactive write (critical)
    state.newFieldSettings = {
      ...state.newFieldSettings,
      ...batch
    }
  },
  [Defaults.Mutations.cleanFieldSettings](state, fieldsToClean) {
    const cleanedNewFieldSettings = Object.keys(state.newFieldSettings)
      .filter(fieldId => !fieldsToClean.includes(fieldId))
      .reduce((result, fieldId) => {
        result[fieldId] = state.newFieldSettings[fieldId]
        return result
      }, {})
    state.newFieldSettings = cleanedNewFieldSettings
  },
  [Defaults.Mutations.setCacheFieldSetting](state, { fieldId, year, row, data }) {
    if (!state.cacheFieldSettings[fieldId]) {
      Vue.set(state.cacheFieldSettings, fieldId, {})
    }
  
    if (!state.cacheFieldSettings[fieldId][year]) {
      Vue.set(state.cacheFieldSettings[fieldId], year, {})
    }
  
    if (!state.cacheFieldSettings[fieldId][year][row]) {
      Vue.set(state.cacheFieldSettings[fieldId][year], row, {})
    }
  
    Object.entries(data).forEach(([key, value]) => {
      Vue.set(state.cacheFieldSettings[fieldId][year][row], key, value)
    })
  },  
  [Defaults.Mutations.clearCacheFieldSettings](state) {
    state.cacheFieldSettings = {}
  },
  [Defaults.Mutations.setOpsSettings](state, opsSettings) {
    state.opsSettings = JSON.parse(opsSettings)
  },
  [Defaults.Mutations.setFertSettings](state, fertSettings) {
    state.fertSettings = JSON.parse(fertSettings)
  },
  [Defaults.Mutations.setPracticeChoices](state, practiceChoices) {
    state.practiceChoices = Object.freeze(practiceChoices);
  },
  [Defaults.Mutations.setPasturePaddocks](pasturePaddocks) {
    
    // state.pasturePaddocks = JSON.parse(pasturePaddocks);
    
  },
  [Defaults.Mutations.addFieldSettingRow](state, payload) {
    const fieldId = payload.fieldId
    const dataCategory = payload.dataCategory
    const fieldSettingYear = payload.year
    const payloadData = payload.dataObj

    const yearKeys = Object.keys(state.newFieldSettings[fieldId]).filter(key => !isNaN(key));

    if(!yearKeys.includes(fieldSettingYear))
      console.error("Setting not found for the year:",fieldSettingYear)

    let dataForYear = state.newFieldSettings[fieldId][fieldSettingYear]
    const firstObject = dataForYear[dataCategory][0]
    const prepData = {...payloadData}

    let result;

    switch (dataCategory) {
      case "operation":
        result = DefaultsAPI.createFieldSetting(
          "pasture-operation-defaults",
          prepData
        )
        break;
      case "live_stock":
        result = DefaultsAPI.createFieldSetting(
          "pasture-livestock-defaults",
          prepData
        )
        break;
      case "feed":
        result = DefaultsAPI.createFieldSetting(
          "pasture-feed-defaults",
          prepData
        )
        break;
      case "stocking":
        result = DefaultsAPI.createFieldSetting(
          "pasture-stocking-defaults",
          prepData
        )
        break;
      case "forage":
        result = DefaultsAPI.createFieldSetting(
          "pasture-forage-defaults",
          prepData
        )
        break;
      default:
        break;
    }
    result.then(response => {
      if(response.status === 200 || response.status === 201) {
        state.newFieldSettings = {
          ...state.newFieldSettings,
          [fieldId]: {
            ...state.newFieldSettings[fieldId],
            [fieldSettingYear]: {
              ...state.newFieldSettings[fieldId][fieldSettingYear],
              [dataCategory]: [
                ...dataForYear[dataCategory],
                response.data1
              ]
            }
          }
        }
      }
    })
  },
  // new code for arva-pre-generated values
  [Defaults.Mutations.deleteNewFieldSetting](state, payload) {
    // payload values
    // fieldId, cropId, dataCategory, rowIndex, year
    const fieldId = payload.fieldId
    const dataCategory = payload.dataCategory
    const fieldSettingYear = payload.year
    const recordId = payload.recordId
    const rowIndex = payload.rowIndex

    const yearKeys = Object.keys(state.newFieldSettings[fieldId]).filter(key => !isNaN(key));

    if(!yearKeys.includes(fieldSettingYear))
      console.error("Record with given year not found",fieldSettingYear)

    let dataForYear = state.newFieldSettings[fieldId][fieldSettingYear]
    

    let result;

    switch (dataCategory) {
      case "operation":
        result = DefaultsAPI.deleteFieldSetting(
          "pasture-operation-defaults",
          recordId
        )
        break;
      case "live_stock":
        result = DefaultsAPI.deleteFieldSetting(
          "pasture-livestock-defaults",
          recordId
        )
        break;
      case "feed":
        result = DefaultsAPI.deleteFieldSetting(
          "pasture-feed-defaults",
          recordId
        )
        break;
      case "stocking":
        result = DefaultsAPI.deleteFieldSetting(
          "pasture-stocking-defaults",
          recordId
        )
        break;
      case "forage":
        result = DefaultsAPI.deleteFieldSetting(
          "pasture-forage-defaults",
          recordId
        )
        break;
      default:
        break;
    }
    result.then(response=>{
      if (response.status === 200 || response.status === 204) {
        state.newFieldSettings = {
          ...state.newFieldSettings,
          [fieldId]: {
            ...state.newFieldSettings[fieldId],
            [fieldSettingYear]: {
              ...state.newFieldSettings[fieldId][fieldSettingYear],
              [dataCategory]: dataForYear[dataCategory].filter(
                (_, index) => index !== rowIndex
              )
            }
          }
        }    
      }
    })

   
  },
  // called when updating individual rows
  // deprecated in favor of saving all data in one call via a save button
  [Defaults.Mutations.updateNewFieldSetting](state, payload) {
    // TODO CONSIDER BETTER MULTIPLE CULTIVATIONS PER YEAR
    // payload values
    // fieldId, cropId, dataCategory, dataSetting, rowIndex, value, year
    const fieldId = payload.fieldId
    const dataCategory = payload.dataCategory
    const fieldSettingYear = payload.year

    let dataForYear = state.newFieldSettings[fieldId].year_data.find(
      dataByYear => dataByYear.year === parseInt(fieldSettingYear)
    )
    let cultivationInFocus = dataForYear.cultivations.find(
      cultiv => cultiv.arva_crop_id === payload.cropId
    )

    // cultivation crop id based on first value in harvests
    // alter all at once to reflect cultivation change
    const operationCategories = IS_RANCHFORCE 
      ? ["grazings", "limings", "irrigations", "biomass"]
      : ["cover_crop", "grazings", "limings", "tillages", "irrigations"]

    if (["arva_crop_id"].includes(dataCategory)) {
      cultivationInFocus["harvests"].forEach(harv => {
        harv["crop_id"]["value"] = payload.value
        harv["crop_id"]["source"] = "User Input"
      })
      const harvestPayload = state.newFieldSettings[fieldId].year_data.map(
        year => {
          let dataByYear = state.newFieldSettings[fieldId].year_data.find(
            dataByYear => dataByYear.year === parseInt(year["year"])
          )
          const harvsForYear = dataByYear.cultivations
            .map(cultiv => cultiv["harvests"])
            .flat()
          return {
            year: year["year"],
            harvests: harvsForYear,
          }
        }
      )
      DefaultsAPI.updateFieldSetting(
        "harvest-defaults",
        cultivationInFocus["harvestId"],
        { data: harvestPayload }
      )
      // cultivationInFocus["arva_crop_id"] = payload.value
    } else if (
      operationCategories.includes(
        dataCategory
      )
    ) {
      if (payload.rowIndex !== null) {
        // grazing, liming, tillage changes
        cultivationInFocus["operations"][dataCategory][payload.rowIndex][
          payload.dataSetting
        ].value = payload.value
        cultivationInFocus["operations"][dataCategory][payload.rowIndex][
          payload.dataSetting
        ].source = "User Input"
      } else {
        // change for cover crop
        cultivationInFocus["operations"][dataCategory][
          payload.dataSetting
        ].value = payload.value
        cultivationInFocus["operations"][dataCategory][
          payload.dataSetting
        ].source = "User Input"
      }

      const apiPayload = state.newFieldSettings[fieldId].year_data.map(year => {
        let dataByYear = state.newFieldSettings[fieldId].year_data.find(
          dataByYear => dataByYear.year === parseInt(year["year"])
        )

        let opsForYear = []
        dataByYear.cultivations.forEach(cultiv =>
          opsForYear.push(cultiv.operations)
        )
        return {
          year: year["year"],
          operations: opsForYear,
        }
      })
      DefaultsAPI.updateFieldSetting(
        "operation-defaults",
        cultivationInFocus["operationId"],
        { data: apiPayload }
      )
    } else if (payload.rowIndex !== null) {
      cultivationInFocus[dataCategory][payload.rowIndex][
        payload.dataSetting
      ].value = payload.value
      cultivationInFocus[dataCategory][payload.rowIndex][
        payload.dataSetting
      ].source = "User Input"

      if (dataCategory === "harvests") {
        const harvestPayload = state.newFieldSettings[fieldId].year_data.map(
          year => {
            let dataByYear = state.newFieldSettings[fieldId].year_data.find(
              dataByYear => dataByYear.year === parseInt(year["year"])
            )
            const harvsForYear = dataByYear.cultivations
              .map(cultiv => cultiv[dataCategory])
              .flat()
            return {
              year: year["year"],
              harvests: harvsForYear,
            }
          }
        )
        DefaultsAPI.updateFieldSetting(
          "harvest-defaults",
          cultivationInFocus["harvestId"],
          { data: harvestPayload }
        )
      } else if (dataCategory === "plantings") {
        const plantingPayload = state.newFieldSettings[fieldId].year_data.map(
          year => {
            let dataByYear = state.newFieldSettings[fieldId].year_data.find(
              dataByYear => dataByYear.year === parseInt(year["year"])
            )
            const plantsForYear = dataByYear.cultivations
              .map(cultiv => cultiv[dataCategory])
              .flat()
            return {
              year: year["year"],
              plantings: plantsForYear,
            }
          }
        )
        DefaultsAPI.updateFieldSetting(
          "planting-defaults",
          cultivationInFocus["plantingId"],
          { data: plantingPayload }
        )
      } else if (dataCategory === "fert_applications") {
        const fertPayload = state.newFieldSettings[fieldId].year_data.map(
          year => {
            let dataByYear = state.newFieldSettings[fieldId].year_data.find(
              dataByYear => dataByYear.year === parseInt(year["year"])
            )
            const fertsForYear = dataByYear.cultivations
              .map(cultiv => cultiv[dataCategory])
              .flat()
            return {
              year: year["year"],
              fert_applications: fertsForYear,
            }
          }
        )
        DefaultsAPI.updateFieldSetting(
          "fertilizer-defaults",
          cultivationInFocus["fertilizerId"],
          { data: fertPayload }
        )
      }
    }
  },
  // save button function
  [Defaults.Mutations.saveDataSpreadsheet](state, payload) {
    const fieldId = payload.fieldId

    const dataForYear = state.newFieldSettings[fieldId].year_data[0]
    const cultivationInFocus = dataForYear.cultivations[0]

    // get planting payload for save
    const plantingPayload = state.newFieldSettings[fieldId].year_data.map(
      year => {
        let dataByYear = state.newFieldSettings[fieldId].year_data.find(
          dataByYear => dataByYear.year === parseInt(year["year"])
        )
        const plantsForYear = dataByYear.cultivations
          .map(cultiv => cultiv["plantings"])
          .flat()
        return {
          year: year["year"],
          plantings: plantsForYear,
        }
      }
    )
    DefaultsAPI.updateFieldSetting(
      "planting-defaults",
      cultivationInFocus["plantingId"],
      { data: plantingPayload }
    )

    // fertilizer payload for save
    const fertPayload = state.newFieldSettings[fieldId].year_data.map(year => {
      let dataByYear = state.newFieldSettings[fieldId].year_data.find(
        dataByYear => dataByYear.year === parseInt(year["year"])
      )
      const fertsForYear = dataByYear.cultivations
        .map(cultiv => cultiv["fert_applications"])
        .flat()
      return {
        year: year["year"],
        fert_applications: fertsForYear,
      }
    })

    DefaultsAPI.updateFieldSetting(
      "fertilizer-defaults",
      cultivationInFocus["fertilizerId"],
      { data: fertPayload }
    )

    // harvest payload for save
    const harvestPayload = state.newFieldSettings[fieldId].year_data.map(
      year => {
        let dataByYear = state.newFieldSettings[fieldId].year_data.find(
          dataByYear => dataByYear.year === parseInt(year["year"])
        )
        const harvsForYear = dataByYear.cultivations
          .map(cultiv => cultiv["harvests"])
          .flat()
        return {
          year: year["year"],
          harvests: harvsForYear,
        }
      }
    )
    DefaultsAPI.updateFieldSetting(
      "harvest-defaults",
      cultivationInFocus["harvestId"],
      { data: harvestPayload }
    )

    // operation payload for save
    const apiPayload = state.newFieldSettings[fieldId].year_data.map(year => {
      let dataByYear = state.newFieldSettings[fieldId].year_data.find(
        dataByYear => dataByYear.year === parseInt(year["year"])
      )

      let opsForYear = []
      dataByYear.cultivations.forEach(cultiv =>
        opsForYear.push(cultiv.operations)
      )
      return {
        year: year["year"],
        operations: opsForYear,
      }
    })

    DefaultsAPI.updateFieldSetting(
      "operation-defaults",
      cultivationInFocus["operationId"],
      { data: apiPayload }
    )

    // crop protection payload for save
    const protectionPayload = state.newFieldSettings[fieldId].year_data.map(
      year => {
        let dataByYear = state.newFieldSettings[fieldId].year_data.find(
          dataByYear => dataByYear.year === parseInt(year["year"])
        )
        const protectionsForYear = dataByYear.cultivations
          .map(cultiv => cultiv["crop_protection"])
          .flat()
        return {
          year: year["year"],
          crop_protection: protectionsForYear,
        }
      }
    )

    DefaultsAPI.updateFieldSetting(
      "crop-protection-defaults",
      cultivationInFocus["cropProtectionId"],
      { data: protectionPayload }
    )

    // soil sampling payload for save
    const samplePayload = state.newFieldSettings[fieldId].year_data.map(
      year => {
        let dataByYear = state.newFieldSettings[fieldId].year_data.find(
          dataByYear => dataByYear.year === parseInt(year["year"])
        )
        const samplesForYear = dataByYear.cultivations
          .map(cultiv => cultiv["soil_sampling"])
          .flat()
        return {
          year: year["year"],
          soil_sampling: samplesForYear,
        }
      }
    )

    DefaultsAPI.updateFieldSetting(
      "soil-sample-defaults",
      cultivationInFocus["samplingId"],
      { data: samplePayload }
    )

    DefaultsAPI.createDataVersion({
      fieldId: fieldId,
      plantingData: plantingPayload,
      harvestData: harvestPayload,
      fertilizerData: fertPayload,
      operationData: apiPayload,
      cropProtectionData: protectionPayload,
      soilSampleData: samplePayload,
    })

    return new Promise(resolve => {
      resolve()
    })
  },
  [Defaults.Mutations.saveDataSpreadsheetRanch](state, payload) {
    const fieldId = payload.fieldId


    const yearKeys = Object.keys(state.newFieldSettings[fieldId]).filter(key => !isNaN(key));

    // const dataForYear = state.newFieldSettings[fieldId][yearKeys[0]]
    // const cultivationInFocus = dataForYear.cultivations[0]

    // fertilizer payload for save
    // const fertPayload = state.newFieldSettings[fieldId].year_data.map(year => {
    //   let dataByYear = state.newFieldSettings[fieldId].year_data.find(
    //     dataByYear => dataByYear.year === parseInt(year["year"])
    //   )
    //   const fertsForYear = dataByYear.cultivations
    //     .map(cultiv => cultiv["fert_applications"])
    //     .flat()
    //   return {
    //     year: year["year"],
    //     fert_applications: fertsForYear,
    //   }
    // })

    // DefaultsAPI.updateFieldSetting(
    //   "pasture-fertilizer-defaults",
    //   cultivationInFocus["fertilizerId"],
    //   { data: fertPayload }
    // )

    // operation payload for save


    const replaceNullYear = (data,year) =>{
      return data.map(object=>{
        if (object?.year === null){
          return { ...object, year }
        }
        return object
      })
    }

    const apiPayload = yearKeys.forEach(year => {
      let dataByYear = state.newFieldSettings[fieldId][year]
      const operation_list = replaceNullYear(dataByYear.operation,year)
      const live_stock_list = replaceNullYear(dataByYear.live_stock,year)
      const feed_list = replaceNullYear(dataByYear.feed,year)
      const stocking_list = replaceNullYear(dataByYear.stocking,year)
      const forage_list = replaceNullYear(dataByYear.forage,year)

      DefaultsAPI.updateBulkFieldSetting(
        "pasture-operation-defaults",
        operation_list
      )

      DefaultsAPI.updateBulkFieldSetting(
        "pasture-livestock-defaults",
        live_stock_list
      )

      DefaultsAPI.updateBulkFieldSetting(
        "pasture-feed-defaults",
        feed_list
      )


      DefaultsAPI.updateBulkFieldSetting(
        "pasture-stocking-defaults",
        stocking_list
      )


      DefaultsAPI.updateBulkFieldSetting(
        "pasture-forage-defaults",
        forage_list
      )

      
      // Todo: for later
      // DefaultsAPI.updateBulkFieldSetting(
      //   "pasture-stocking-defaults",
      // )
  

      // Todo: for later
      // DefaultsAPI.updateBulkFieldSetting(
      // "pasture-forage-defaults",
      // )

      // DefaultsAPI.createDataVersionPasture({
      //   fieldId: fieldId,
      //   fertilizerData: fertPayload,
      //   operationData: apiPayload,
      //   cropProtectionData: protectionPayload,
      //   soilSampleData: samplePayload,
      //   liveStockData: livestockPayload,
      //   bqaData: bqaPayload,
      //   burnData: burnPayload,
      //   conservationData: conservationPayload,
      //   feedData: feedPayload,
      //   invadedData: invadedPayload,
      //   seedData: seedPayload,
      //   supplyData: supplyPayload,
      //   technologyData: technologyPayload,
      //   forageData: foragePayload,
      //   stockingData: stockingPayload,
      // })

      // return {
      //   year: year["year"],
      //   operations: opsForYear,
      // }
    })

    



    // crop protection payload for save
    // const protectionPayload = state.newFieldSettings[fieldId].year_data.map(
    //   year => {
    //     let dataByYear = state.newFieldSettings[fieldId].year_data.find(
    //       dataByYear => dataByYear.year === parseInt(year["year"])
    //     )
    //     const protectionsForYear = dataByYear.cultivations
    //       .map(cultiv => cultiv["crop_protection"])
    //       .flat()
    //     return {
    //       year: year["year"],
    //       crop_protection: protectionsForYear,
    //     }
    //   }
    // )

    // DefaultsAPI.updateFieldSetting(
    //   "pasture-crop-protection-defaults",
    //   cultivationInFocus["cropProtectionId"],
    //   { data: protectionPayload }
    // )

    // soil sampling payload for save
    // const samplePayload = state.newFieldSettings[fieldId].year_data.map(
    //   year => {
    //     let dataByYear = state.newFieldSettings[fieldId].year_data.find(
    //       dataByYear => dataByYear.year === parseInt(year["year"])
    //     )
    //     const samplesForYear = dataByYear.cultivations
    //       .map(cultiv => cultiv["soil_sampling"])
    //       .flat()
    //     return {
    //       year: year["year"],
    //       soil_sampling: samplesForYear,
    //     }
    //   }
    // )

    // DefaultsAPI.updateFieldSetting(
    //   "pasture-soil-sample-defaults",
    //   cultivationInFocus["samplingId"],
    //   { data: samplePayload }
    // )




    // bqa payload for save
    // const bqaPayload = state.newFieldSettings[fieldId].year_data.map(
    //   year => {
    //     let dataByYear = state.newFieldSettings[fieldId].year_data.find(
    //       dataByYear => dataByYear.year === parseInt(year["year"])
    //     )
    //     const bqaForYear = dataByYear.cultivations
    //       .map(cultiv => cultiv["bqa"])
    //       .flat()
    //     return {
    //       year: year["year"],
    //       bqa: bqaForYear,
    //     }
    //   }
    // )

    // DefaultsAPI.updateFieldSetting(
    //   "pasture-bqa-defaults",
    //   cultivationInFocus["bqaId"],
    //   { data: bqaPayload }
    // )

    // burn payload for save
    // const burnPayload = state.newFieldSettings[fieldId].year_data.map(
    //   year => {
    //     let dataByYear = state.newFieldSettings[fieldId].year_data.find(
    //       dataByYear => dataByYear.year === parseInt(year["year"])
    //     )
    //     const burnForYear = dataByYear.cultivations
    //       .map(cultiv => cultiv["burn"])
    //       .flat()
    //     return {
    //       year: year["year"],
    //       burn: burnForYear,
    //     }
    //   }
    // )

    // DefaultsAPI.updateFieldSetting(
    //   "pasture-burn-defaults",
    //   cultivationInFocus["burnId"],
    //   { data: burnPayload }
    // )

    // conservation payload for save
    // const conservationPayload = state.newFieldSettings[fieldId].year_data.map(
    //   year => {
    //     let dataByYear = state.newFieldSettings[fieldId].year_data.find(
    //       dataByYear => dataByYear.year === parseInt(year["year"])
    //     )
    //     const conservationForYear = dataByYear.cultivations
    //       .map(cultiv => cultiv["conservation"])
    //       .flat()
    //     return {
    //       year: year["year"],
    //       conservation: conservationForYear,
    //     }
    //   }
    // )

    // DefaultsAPI.updateFieldSetting(
    //   "pasture-conservation-defaults",
    //   cultivationInFocus["conservationId"],
    //   { data: conservationPayload }
    // )

    // feed payload for save
    // const feedPayload = state.newFieldSettings[fieldId].year_data.map(
    //   year => {
    //     let dataByYear = state.newFieldSettings[fieldId].year_data.find(
    //       dataByYear => dataByYear.year === parseInt(year["year"])
    //     )
    //     const feedForYear = dataByYear.cultivations
    //       .map(cultiv => cultiv["feed"])
    //       .flat()
    //     return {
    //       year: year["year"],
    //       feed: feedForYear,
    //     }
    //   }
    // )

    // DefaultsAPI.updateFieldSetting(
    //   "pasture-feed-defaults",
    //   cultivationInFocus["feedId"],
    //   { data: feedPayload }
    // )

    // invaded payload for save
    // const invadedPayload = state.newFieldSettings[fieldId].year_data.map(
    //   year => {
    //     let dataByYear = state.newFieldSettings[fieldId].year_data.find(
    //       dataByYear => dataByYear.year === parseInt(year["year"])
    //     )
    //     const invadedForYear = dataByYear.cultivations
    //       .map(cultiv => cultiv["invaded"])
    //       .flat()
    //     return {
    //       year: year["year"],
    //       invaded: invadedForYear,
    //     }
    //   }
    // )

    // DefaultsAPI.updateFieldSetting(
    //   "pasture-invaded-defaults",
    //   cultivationInFocus["invadedId"],
    //   { data: invadedPayload }
    // )

    // seed payload for save
    // const seedPayload = state.newFieldSettings[fieldId].year_data.map(
    //   year => {
    //     let dataByYear = state.newFieldSettings[fieldId].year_data.find(
    //       dataByYear => dataByYear.year === parseInt(year["year"])
    //     )
    //     const seedForYear = dataByYear.cultivations
    //       .map(cultiv => cultiv["seed"])
    //       .flat()
    //     return {
    //       year: year["year"],
    //       seed: seedForYear,
    //     }
    //   }
    // )

    // DefaultsAPI.updateFieldSetting(
    //   "pasture-seed-defaults",
    //   cultivationInFocus["seedId"],
    //   { data: seedPayload }
    // )

    // supply payload for save
    // const supplyPayload = state.newFieldSettings[fieldId].year_data.map(
    //   year => {
    //     let dataByYear = state.newFieldSettings[fieldId].year_data.find(
    //       dataByYear => dataByYear.year === parseInt(year["year"])
    //     )
    //     const supplyForYear = dataByYear.cultivations
    //       .map(cultiv => cultiv["supply"])
    //       .flat()
    //     return {
    //       year: year["year"],
    //       supply: supplyForYear,
    //     }
    //   }
    // )

    // DefaultsAPI.updateFieldSetting(
    //   "pasture-supply-defaults",
    //   cultivationInFocus["supplyId"],
    //   { data: supplyPayload }
    // )

    // technology payload for save
    // const technologyPayload = state.newFieldSettings[fieldId].year_data.map(
    //   year => {
    //     let dataByYear = state.newFieldSettings[fieldId].year_data.find(
    //       dataByYear => dataByYear.year === parseInt(year["year"])
    //     )
    //     const technologyForYear = dataByYear.cultivations
    //       .map(cultiv => cultiv["technology"])
    //       .flat()
    //     return {
    //       year: year["year"],
    //       technology: technologyForYear,
    //     }
    //   }
    // )

    // DefaultsAPI.updateFieldSetting(
    //   "pasture-technology-defaults",
    //   cultivationInFocus["technologyId"],
    //   { data: technologyPayload }
    // )

    // forage payload for save
    // const foragePayload = state.newFieldSettings[fieldId].year_data.map(
    //   year => {
    //     let dataByYear = state.newFieldSettings[fieldId].year_data.find(
    //       dataByYear => dataByYear.year === parseInt(year["year"])
    //     )
    //     const forageForYear = dataByYear.cultivations
    //       .map(cultiv => cultiv["forage"])
    //       .flat()
    //     return {
    //       year: year["year"],
    //       forage: forageForYear,
    //     }
    //   }
    // )

    // DefaultsAPI.updateFieldSetting(
    //   "pasture-forage-defaults",
    //   cultivationInFocus["forageId"],
    //   { data: foragePayload }
    // )

    // stocking payload for save
    // const stockingPayload = state.newFieldSettings[fieldId].year_data.map(
    //   year => {
    //     let dataByYear = state.newFieldSettings[fieldId].year_data.find(
    //       dataByYear => dataByYear.year === parseInt(year["year"])
    //     )
    //     const stockingForYear = dataByYear.cultivations
    //       .map(cultiv => cultiv["stocking"])
    //       .flat()
    //     return {
    //       year: year["year"],
    //       stocking: stockingForYear,
    //     }
    //   }
    // )

    // DefaultsAPI.updateFieldSetting(
    //   "pasture-stocking-defaults",
    //   cultivationInFocus["stockingId"],
    //   { data: stockingPayload }
    // )

    // DefaultsAPI.createDataVersionPasture({
    //   fieldId: fieldId,
    //   fertilizerData: fertPayload,
    //   operationData: apiPayload,
    //   cropProtectionData: protectionPayload,
    //   soilSampleData: samplePayload,
    //   liveStockData: livestockPayload,
    //   bqaData: bqaPayload,
    //   burnData: burnPayload,
    //   conservationData: conservationPayload,
    //   feedData: feedPayload,
    //   invadedData: invadedPayload,
    //   seedData: seedPayload,
    //   supplyData: supplyPayload,
    //   technologyData: technologyPayload,
    //   forageData: foragePayload,
    //   stockingData: stockingPayload,
    // })

    return new Promise(resolve => {
      resolve()
    })
  },
  [Defaults.Mutations.updateMultipleNewFieldSetting](state, payload) {
    // payload values
    // cropId, dataCategory, fieldId, rowData (data being added), years
    const fieldId = payload.fieldId
    const dataCategory = payload.dataCategory

    payload.years.forEach(year => {
      const yearInFocus = year
      let dataForYear = state.newFieldSettings[fieldId].year_data.find(
        dataByYear => dataByYear.year === parseInt(yearInFocus)
      )
      let cultivationInFocus = dataForYear.cultivations.find(
        cultiv => cultiv.arva_crop_id === payload.cropId
      )
        ? dataForYear.cultivations.find(
            cultiv => cultiv.arva_crop_id === payload.cropId
          )
        : dataForYear.cultivations[0]
      
      const operationCategories = IS_RANCHFORCE 
        ? ["grazings", "limings", "irrigations", "biomass"]
        : ["grazings", "limings", "tillages", "irrigations"]
      if (
        operationCategories.includes(
          dataCategory
        )
      ) {
        cultivationInFocus["operations"][dataCategory].push(payload.rowData)
      } else {
        cultivationInFocus[dataCategory].push(payload.rowData)
      }

      if (
        operationCategories.includes(
          dataCategory
        )
      ) {
        const apiPayload = state.newFieldSettings[fieldId].year_data.map(
          pYear => {
            let dataByYear = state.newFieldSettings[fieldId].year_data.find(
              dataByYear => dataByYear.year === parseInt(pYear["year"])
            )
            // TODO CONSIDER BETTER MULTIPLE CULTIVATIONS PER YEAR
            const opsForYear = {}
            opsForYear["limings"] = dataByYear.cultivations
              .map(cultiv => cultiv["operations"]["limings"])
              .flat()
            opsForYear["grazings"] = dataByYear.cultivations
              .map(cultiv => cultiv["operations"]["grazings"])
              .flat()
            opsForYear["tillages"] = dataByYear.cultivations
              .map(cultiv => cultiv["operations"]["tillages"])
              .flat()
            opsForYear["irrigations"] = dataByYear.cultivations
              .map(cultiv => cultiv["operations"]["irrigations"])
              .flat()
            opsForYear["drainage"] =
              dataByYear["cultivations"][0]["operations"]["drainage"]
            return {
              year: pYear["year"],
              operations: opsForYear,
            }
          }
        )
        DefaultsAPI.updateFieldSetting(
          "operation-defaults",
          cultivationInFocus["operationId"],
          { data: apiPayload }
        )
      } else {
        if (dataCategory === "harvests") {
          const harvestPayload = state.newFieldSettings[fieldId].year_data.map(
            pYear => {
              let dataByYear = state.newFieldSettings[fieldId].year_data.find(
                dataByYear => dataByYear.year === parseInt(pYear["year"])
              )
              const harvsForYear = dataByYear.cultivations
                .map(cultiv => cultiv[dataCategory])
                .flat()
              return {
                year: pYear["year"],
                harvests: harvsForYear,
              }
            }
          )
          DefaultsAPI.updateFieldSetting(
            "harvest-defaults",
            cultivationInFocus["harvestId"],
            { data: harvestPayload }
          )
        } else if (dataCategory === "plantings") {
          const plantingPayload = state.newFieldSettings[fieldId].year_data.map(
            pYear => {
              let dataByYear = state.newFieldSettings[fieldId].year_data.find(
                dataByYear => dataByYear.year === parseInt(pYear["year"])
              )
              const plantsForYear = dataByYear.cultivations
                .map(cultiv => cultiv[dataCategory])
                .flat()
              return {
                year: pYear["year"],
                plantings: plantsForYear,
              }
            }
          )
          DefaultsAPI.updateFieldSetting(
            "planting-defaults",
            cultivationInFocus["plantingId"],
            { data: plantingPayload }
          )
        } else if (dataCategory === "fert_applications") {
          const fertPayload = state.newFieldSettings[fieldId].year_data.map(
            pYear => {
              let dataByYear = state.newFieldSettings[fieldId].year_data.find(
                dataByYear => dataByYear.year === parseInt(pYear["year"])
              )
              const fertsForYear = dataByYear.cultivations
                .map(cultiv => cultiv[dataCategory])
                .flat()
              return {
                year: pYear["year"],
                fert_applications: fertsForYear,
              }
            }
          )
          DefaultsAPI.updateFieldSetting(
            "fertilizer-defaults",
            cultivationInFocus["fertilizerId"],
            { data: fertPayload }
          )
        }
      }
    })
  },
  [Defaults.Mutations.spreadsheetMutate](state, payload) {
    const fieldId = payload.fieldId
    const year = payload.year
    const crop = payload.crop
    const dataCategory = payload.dataCategory
    const dataSetting = payload.dataSetting
    const rowIndex = payload.rowIndex
    const payloadVal = payload.value

    state.spreadsheetNeedsSave = true

    let fieldToMutate = state.newFieldSettings[fieldId]
    if (!fieldToMutate) {
      console.error("No Field Found")
    }

    const yearKeys = Object.keys(fieldToMutate).filter(key => !isNaN(key));

    if(!yearKeys.includes(year)){
      console.error("No Year Found")
    }

    let yearData = fieldToMutate[year]
    // let cultivation = yearData[dataCategory].find(
    //   c => c.id == crop
    // )

    const operationCategories = IS_RANCHFORCE 
    // original line ["grazings", "limings", "irrigations", "biomass"]
      ? ["operation","live_stock","feed"]
      : ["cover_crop", "grazings", "limings", "tillages", "irrigations"]

    if (
      operationCategories.includes(
        dataCategory
      )
    ) {
      // yearData[dataCategory][rowIndex][dataSetting] = payloadVal
      const rows = yearData[dataCategory];
      if (!Array.isArray(rows)) return console.error("No Category Array", dataCategory);

      const oldRow = rows[rowIndex];
      if (!oldRow) return console.error("No Row Found", rowIndex);

      // ---- immutable update (works with Object.freeze) ----
      const newRow = Object.freeze({
        ...oldRow,
        [dataSetting]: payloadVal
      });

      const newRows = rows.map((r, i) => (i === rowIndex ? newRow : r));
      Object.freeze(newRows);

      const newYearData = { ...yearData, [dataCategory]: newRows };
      Object.freeze(newYearData);

      const newField = { ...fieldToMutate, [year]: newYearData };
      Object.freeze(newField);

      // single reactive write
      state.newFieldSettings = {
        ...state.newFieldSettings,
        [fieldId]: newField
      };

    } else {
      // yearData[dataCategory][rowIndex][dataSetting] = payloadVal
      const rows = yearData[dataCategory];
      if (!Array.isArray(rows)) return console.error("No Category Array", dataCategory);

      const oldRow = rows[rowIndex];
      if (!oldRow) return console.error("No Row Found", rowIndex);

      // ---- immutable update (works with Object.freeze) ----
      const newRow = Object.freeze({
        ...oldRow,
        [dataSetting]: payloadVal
      });

      const newRows = rows.map((r, i) => (i === rowIndex ? newRow : r));
      Object.freeze(newRows);

      const newYearData = { ...yearData, [dataCategory]: newRows };
      Object.freeze(newYearData);

      const newField = { ...fieldToMutate, [year]: newYearData };
      Object.freeze(newField);

      // single reactive write
      state.newFieldSettings = {
        ...state.newFieldSettings,
        [fieldId]: newField
      };

    }
  },
  [Defaults.Mutations.resetNeedsSave](state) {
    state.spreadsheetNeedsSave = false
  },
  [Defaults.Mutations.setRecentWizardData](state, payload) {
    state.recentWizardData = payload
  },
  [Defaults.Mutations.resetRecentWizardData](state) {
    state.recentWizardData = { wizard: null, data: null }
  },
}

const actions = {
  [Defaults.Actions.fetchDefaults]({ commit }) {
    return new Promise(resolve => {
      DefaultsAPI.list().then(response => {
        
        commit(Defaults.Mutations.setDefaults, response.data)
        resolve()
      })
    })
  },
  [Defaults.Actions.fetchFieldSettings]({ commit }) {
    return new Promise(resolve => {
      DefaultsAPI.listFieldSettings().then(response => {
 
        
        commit(Defaults.Mutations.setFieldSettings, response.data)
        resolve()
      })
    })
  },
  [Defaults.Actions.spreadsheetUpdate]({ commit }, payload) {
    commit(Defaults.Mutations.spreadsheetMutate, payload)
  
    commit(Defaults.Mutations.setCacheFieldSetting, {
      fieldId: payload.fieldId,
      year: payload.year,
      row:payload.rowIndex,
      data: {
        [payload.dataSetting]: payload.value
      }
    })
  },
  [Defaults.Actions.updateCacheFieldSetting]({ commit }, payload) {
    commit(Defaults.Mutations.setCacheFieldSetting, payload)
  },
  [Defaults.Actions.clearCacheFieldSettings]({ commit }) {
    commit(Defaults.Mutations.clearCacheFieldSettings)
  },
  // new fetch
  [Defaults.Actions.fetchNewFieldSettings]({ commit }) {
    return new Promise(resolve => {
      DefaultsAPI.getNewFieldSettings().then(response => {
        commit(Defaults.Mutations.setNewFieldSettings, response.data)
        resolve()
      })
    })
  },
  [Defaults.Actions.fetchOpsSettings]({ commit }, payload) {
    return new Promise(resolve => {
      DefaultsAPI.getCarbonOpsByField(payload)
        .catch(error => {
          console.error(error)
          resolve(error)
        })
        .then(response => {
          commit(Defaults.Mutations.setOpsSettings, response.data)
          resolve()
        })
    })
  },
  [Defaults.Actions.fetchFertSettings]({ commit }, payload) {
    return new Promise(resolve => {
      DefaultsAPI.getCarbonFertByField(payload)
        .catch(error => {
          console.error(error)
          resolve(error)
        })
        .then(response => {
          commit(Defaults.Mutations.setFertSettings, response.data)
          resolve()
        })
    })
  },
  [Defaults.Actions.fetchPracticeChoices]({ commit }) {
    return new Promise(resolve => {
      DefaultsAPI.getPracticeChoices()
        .catch(error => {
          console.error(error)
          resolve(error)
        })
        .then(response => {
          commit(Defaults.Mutations.setPracticeChoices, response.data)
          resolve()
        })
    })
  },
  [Defaults.Actions.fetchPasturePaddocks]({ commit, state }, payload) {
    return new Promise(resolve => {
      DefaultsAPI.getPasturePaddocks(payload)
        .catch(error => {
          console.error(error)
          resolve(error)
        })
        .then(response => {
          state.pasturePaddocks = response.data;
          resolve();
        })
    })
  },
  [Defaults.Actions.fetchCarbonSettingsByField]({ commit, state }, payload) {
    const checkExistingState = payload.checkExistingState !== undefined ? payload.checkExistingState : true;

    let fieldsForFetch = payload.fieldIds

    if (checkExistingState) {
      // check for field ids already in state, clear any unwanted fields from local data
      let fieldsInState = Object.keys(state.newFieldSettings).map(v => Number(v))
      fieldsForFetch = payload.fieldIds.filter(
        f => !fieldsInState.includes(f)
      )
      let fieldsToClean = fieldsInState.filter(f => !payload.fieldIds.includes(f))
      if (fieldsToClean.length > 0) {
        commit(Defaults.Mutations.cleanFieldSettings, fieldsToClean)
      }
    }

    if (fieldsForFetch.length > 0) {
      if (fieldsForFetch.length < MAX_DEFAULT_FIELDS) {
        payload.fieldIds = fieldsForFetch
          return IS_RANCHFORCE ?
            new Promise(resolve => {
              DefaultsAPI.getPastureCarbonSettingsByField(payload)
                .then(response => {
                  commit(Defaults.Mutations.addToFieldSettings, response.data)
                  resolve()       
                })
                .catch(error => {
                  console.error("Error in getPastureCarbonSettingsByField", error)
                  resolve(error)
                })
            })
          :
            new Promise(resolve => {
              DefaultsAPI.getCarbonSettingsByField(payload)
                .catch(error => {
                  console.error(error)
                  resolve(error)
                })
                .then(response => {
                  commit(Defaults.Mutations.addToFieldSettings, response.data)
                  resolve()
                })
            })
      } else {
        return Promise.resolve()
      }
    } else {
      return Promise.resolve()
    }
  },
  // Adds/copies submitted rowData to multiple fields
  [Defaults.Actions.updateMultipleFieldSettings]({ commit }, payload) {
    payload.fieldIds.forEach(fieldId => {
      commit(Defaults.Mutations.updateMultipleNewFieldSetting, {
        cropId: payload.cropId,
        dataCategory: payload.dataCategory,
        fieldId: fieldId,
        rowData: payload.rowData,
        years: payload.years,
      })
    })
  },
  [Defaults.Actions.saveDataSpreadsheet]({ commit }, payload) {
    return new Promise(resolve => {
      commit(Defaults.Mutations.saveDataSpreadsheet, payload)
      resolve()
    })
  },
  [Defaults.Actions.saveDataSpreadsheetRanch]({ commit }, payload) {
    return new Promise(resolve => {
      commit(Defaults.Mutations.saveDataSpreadsheetRanch, payload)
      commit(Defaults.Mutations.clearCacheFieldSettings)
      resolve()
    })
  },
  async [Defaults.Actions.updateIrrigation]({ state }, payload) {
    const fieldId = payload.fieldId
    const year = payload.year
    let operationId = state.newFieldSettings[fieldId].operation_id

    let dataForYear = state.newFieldSettings[fieldId].year_data.find(
      dataByYear => dataByYear.year === parseInt(year)
    )

    dataForYear.cultivations.forEach(cultiv => {
      const cropFilteredPayload = payload.irrigation.filter(
        o => o.crop_id.value == cultiv.arva_crop_id
      )
      if (cropFilteredPayload.length > 0) {
        cultiv["operations"]["irrigations"] = cropFilteredPayload
      }
      cultiv["operations"]["drainage"] = payload.drainage
    })

    const apiPayload = state.newFieldSettings[fieldId].year_data.map(year => {
      let dataByYear = state.newFieldSettings[fieldId].year_data.find(
        dataForYear => dataForYear.year === parseInt(year["year"])
      )
      let opsForYear = []
      dataByYear.cultivations.forEach(cultiv =>
        opsForYear.push(cultiv.operations)
      )
      return {
        year: year["year"],
        operations: opsForYear,
      }
    })

    const queryParams = { field_id: fieldId, year_modified: year }
    await DefaultsAPI.updateFieldSetting("operation-defaults", operationId, {
      data: apiPayload,
    }, queryParams)
  },
  async [Defaults.Actions.updateTillage]({ state }, payload) {
    const fieldId = payload.fieldId
    const year = payload.year
    let operationId = state.newFieldSettings[fieldId].operation_id

    let dataForYear = state.newFieldSettings[fieldId].year_data.find(
      dataByYear => dataByYear.year === parseInt(year)
    )

    // sets tillage for each cultivation in field
    dataForYear.cultivations.forEach(cultiv => {
      const cropFilteredPayload = payload.tillages.filter(
        o => o.crop_id.value == cultiv.arva_crop_id
      )
      if (cropFilteredPayload.length > 0) {
        cultiv["operations"]["tillages"] = cropFilteredPayload
      }
      // cultiv["operations"]["tillages"] = payload.tillages
    })

    const apiPayload = state.newFieldSettings[fieldId].year_data.map(year => {
      let dataByYear = state.newFieldSettings[fieldId].year_data.find(
        dataForYear => dataForYear.year === parseInt(year["year"])
      )
      let opsForYear = []
      dataByYear.cultivations.forEach(cultiv =>
        opsForYear.push(cultiv.operations)
      )
      return {
        year: year["year"],
        operations: opsForYear,
      }
    })

    const queryParams = { field_id: fieldId, year_modified: year }
    await DefaultsAPI.updateFieldSetting("operation-defaults", operationId, {
      data: apiPayload,
    }, queryParams)
  },
  async [Defaults.Actions.updateFertilizer]({ state }, payload) {
    const fieldId = payload.fieldId
    const year = payload.year
    let fertilizerId = state.newFieldSettings[fieldId].fertilizer_id

    let dataForYear = state.newFieldSettings[fieldId].year_data.find(
      dataByYear => dataByYear.year === parseInt(year)
    )

    dataForYear.cultivations.forEach(cultiv => {
      const cropFilteredPayload = payload.fertApplications.filter(
        o => o.crop_id.value == cultiv.arva_crop_id
      )
      if (cropFilteredPayload.length > 0) {
        cultiv["fert_applications"] = cropFilteredPayload
      }
    })

    const fertPayload = state.newFieldSettings[fieldId].year_data.map(year => {
      let dataByYear = state.newFieldSettings[fieldId].year_data.find(
        dataByYear => dataByYear.year === parseInt(year["year"])
      )
      const fertsForYear = dataByYear.cultivations
        .map(cultiv => cultiv["fert_applications"])
        .flat()
      return {
        year: year["year"],
        fert_applications: fertsForYear,
      }
    })

    const queryParams = { field_id: fieldId, year_modified: year }
    await DefaultsAPI.updateFieldSetting("fertilizer-defaults", fertilizerId, {
      data: fertPayload,
    }, queryParams)
  },
  async [Defaults.Actions.updateProtection]({ state }, payload) {
    const fieldId = payload.fieldId
    const year = payload.year
    let protectionId = state.newFieldSettings[fieldId].crop_protection_id

    let dataForYear = state.newFieldSettings[fieldId].year_data.find(
      dataByYear => dataByYear.year === parseInt(year)
    )

    dataForYear.cultivations.forEach(cultiv => {
      const cropFilteredPayload = payload.protectionPayload.filter(
        o => o.crop_id.value == cultiv.arva_crop_id
      )
      if (cropFilteredPayload.length > 0) {
        cultiv["crop_protection"] = cropFilteredPayload
      }
    })

    const protectionDatabasePayload = state.newFieldSettings[
      fieldId
    ].year_data.map(year => {
      let dataByYear = state.newFieldSettings[fieldId].year_data.find(
        dataByYear => dataByYear.year === parseInt(year["year"])
      )
      const protectionForYear = dataByYear.cultivations
        .map(cultiv => cultiv["crop_protection"])
        .flat()
      return {
        year: year["year"],
        crop_protection: protectionForYear,
      }
    })

    const queryParams = { field_id: fieldId, year_modified: year }
    await DefaultsAPI.updateFieldSetting(
      "crop-protection-defaults",
      protectionId,
      {
        data: protectionDatabasePayload,
      },
      queryParams
    )
  },
  async [Defaults.Actions.updateCoverCropping]({ state }, payload) {
    const fieldId = payload.fieldId
    const year = payload.year

    let operationId = state.newFieldSettings[fieldId].operation_id

    let dataForYear = state.newFieldSettings[fieldId].year_data.find(
      dataByYear => dataByYear.year === parseInt(year)
    )

    dataForYear.cultivations.forEach(cultiv => {
      const cropFilteredPayload = payload.coverCropping.filter(
        o => o.crop_id.value == cultiv.arva_crop_id
      )
      if (cropFilteredPayload.length > 0) {
        cultiv["operations"]["cover_crop"] = cropFilteredPayload
      }
    })

    const apiPayload = state.newFieldSettings[fieldId].year_data.map(year => {
      let dataByYear = state.newFieldSettings[fieldId].year_data.find(
        dataForYear => dataForYear.year === parseInt(year["year"])
      )
      let opsForYear = []
      dataByYear.cultivations.forEach(cultiv =>
        opsForYear.push(cultiv.operations)
      )
      return {
        year: year["year"],
        operations: opsForYear,
      }
    })

    const queryParams = { field_id: fieldId, year_modified: year }
    await DefaultsAPI.updateFieldSetting("operation-defaults", operationId, {
      data: apiPayload,
    }, queryParams)
  },  
  async [Defaults.Mutations.updatePlanting]({ state }, payload) {
    const fieldId = payload.fieldId
    const year = payload.year
    const plantingId = state.newFieldSettings[fieldId].planting_id

    const existingYears = [];
    const apiPayload = state.newFieldSettings[fieldId].year_data.map(existingYearData => {
      existingYears.push(existingYearData.year)
      if (existingYearData.year === parseInt(year)) {
        return {
          year: existingYearData.year,
          plantings: payload.plantingPayload
        }
      } else {
        const plantingsForYear = existingYearData.cultivations
          .map(cultiv => cultiv["plantings"])
          .flat()

        return {
          year: existingYearData.year,
          plantings: plantingsForYear,
        }
      }
    })

    if (!existingYears.includes(parseInt(year))) {
      const newYearData = {
        year: parseInt(year),
        plantings: payload.plantingPayload,
      }
      apiPayload.push(newYearData)
    }

    const queryParams = { field_id: fieldId, year_modified: year }
    await DefaultsAPI.updateFieldSetting("planting-defaults", plantingId, {
      data: apiPayload,
    }, queryParams)
  },
  async [Defaults.Actions.updateLiming]({ state }, payload) {
    const fieldId = payload.fieldId
    const year = payload.year
    let operationId = state.newFieldSettings[fieldId].operation_id

    let dataForYear = state.newFieldSettings[fieldId].year_data.find(
      dataByYear => dataByYear.year === parseInt(year)
    )

    // sets liming for each cultivation in field
    dataForYear.cultivations.forEach(cultiv => {
      const cropFilteredPayload = payload.limingPayload.filter(
        o => o.crop_id.value == cultiv.arva_crop_id
      )
      if (cropFilteredPayload.length > 0) {
        cultiv["operations"]["limings"] = cropFilteredPayload
      }
    })

    const apiPayload = state.newFieldSettings[fieldId].year_data.map(year => {
      let dataByYear = state.newFieldSettings[fieldId].year_data.find(
        dataForYear => dataForYear.year === parseInt(year["year"])
      )
      let opsForYear = []
      dataByYear.cultivations.forEach(cultiv =>
        opsForYear.push(cultiv.operations)
      )
      return {
        year: year["year"],
        operations: opsForYear,
      }
    })
    
    const queryParams = { field_id: fieldId, year_modified: year }
    await DefaultsAPI.updateFieldSetting("operation-defaults", operationId, {
      data: apiPayload,
    }, queryParams)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
